module.exports = __webpack_public_path__ + "static/img/icon_cloud7.161aa09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud7.jpg
// module id = +lDl
// module chunks = 21